<template>
    <Header></Header>
        <main> 
            <Banner :fields="fields['First Section']"></Banner>
            
            <BlockWrapperAbout style="padding-top: 180px;">
                <template #right><ImageBlock :fields="fields['Second section']"></ImageBlock></template>
                <template #left><TextBlock :fields="fields['Second section']"></TextBlock></template>
            </BlockWrapperAbout>
            <SloganTempateLow style="padding-top: 180px; padding-bottom: 160px;" :fields="fields['Third section']"></SloganTempateLow>
            <PosotionImgContentLeft :content="{
            imagePosition: 'left'
        }"></PosotionImgContentLeft>
            <BlockWrapperAbout class="leftp" style="padding-top: 180px;">
                <template #left><ImageBlock :fields="fields['Fourth section']"></ImageBlock></template>
                <template #right><TextBlock :fields="fields['Fourth section']"></TextBlock></template>
            </BlockWrapperAbout>
            <FaqBlock style="padding-top: 140px; padding-bottom: 140px;"></FaqBlock>
        </main>
    <Footer></Footer>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import Footer from "@/components/Footer/Footer.vue";
import FaqBlock from "@/components/Templates/FaqBlock.vue";
import PosotionImgContentLeft from "@/components/Templates/PosotionImgContentLeft.vue";
import Banner from "@/components/Services/Banner.vue";
import SloganTempateLow from "@/components/Services/SloganTempateLow.vue";
import BlockWrapperAbout from "@/components/Services/BlockWrapperAbout.vue";
import ImageBlock from "@/components/Services/ImageBlock.vue";
import TextBlock from "@/components/Services/TextBlock.vue";
import { registerAnimations } from '@/assets/directives/animations';
import axios from "axios";
    export default {
        components: {
            Header,
            Footer,
            FaqBlock,
            PosotionImgContentLeft,
            Banner,
            SloganTempateLow,
            BlockWrapperAbout,
            ImageBlock,
            TextBlock
        },
        computed: {
        fields() {
                return this.$store.state.fields;
            },
        },
        watch: {
        '$route': 'fetchData', // Следим за изменением маршрута
        },
        methods: {
        fetchData() {
            axios.get('/api/data', { params: { url: this.$route.path } })
            .then(response => {
                this.$nextTick(() => {
                    registerAnimations(); // Инициализация анимаций после загрузки данных
                });
            });
        },
        },
        created() {
        this.fetchData(); // Загружаем данные при создании компонента
        },
    }
</script>

<style scoped>

</style>